import axios from "axios";
import { api } from "./api_route";

export const searchArbitratorAllocationAPI = async (payload) => {
  try {
    const response = await axios.post(
      `${api}/arbitratorAllocation/search`,
      payload,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const submitArbitratorMappingAPI = async (payload) => {
  try {
    const response = await axios.post(
      `${api}/arbitratorAllocation/mapping`,
      payload,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

